import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    getMonthNames(): string[] {
        return ['JAN', 'FEB', 'MAR', 'APR', 'MAÍ', 'JÚN', 'JÚL', 'ÁGU', 'SEP', 'OKT', 'NÓV', 'DES'];
    }
}
